<!-- Button -->
<!-- 
    color:按鈕顏色，若color-config內沒有想要的顏色，可自行新增
    text: 顯示於按鈕內的文字(文字預設折2行，若需要更改請自訂textClass)
    fontSize: 三種規格-small:1.5rem normal:1.9rem large:2.2rem 預設為large
    width: 六種規格-100/50/30/25/20/15，適用於flex排版
    selected: 該按鈕被選中，顏色為綠色，適用於radio
    disabled: 該按鈕禁用，顏色為opacity:0.6
    isButton: false不是按鈕，純樣式，取消點擊行為
    closeTransition: 是否取消transition動畫，預設為false
    buttonClass: 可自定義class改樣式(須加:deep)
    textClass: 針對文字的自定義Class(須加:deep)
    topIcon/topIconClass: 文字上方的icon(使用bootstrap-icons)，可自定義class改樣式(須加:deep)
    leftIcon/leftIconClass: 文字左方的icon(使用bootstrap-icons)，可自定義class改樣式(須加:deep)
-->
<template>
  <div
    class="cus-button-wrap"
    :class="[wrapClassObj, fontSize !== 'large' ? 'small-height' : '']"
    data-name="cus-button"
  >
    <div :class="classObj" tabindex="-1" data-name="cus-button">
      <div v-if="topIcon" class="button-top-icon" data-name="cus-button">
        <i :class="`bi bi-${topIcon} ${topIconClass}`" data-name="cus-button"></i>
      </div>
      <p :class="`button-text ${textClass}`" data-name="cus-button">
        <i v-if="leftIcon" :class="`bi bi-${leftIcon} ${leftIconClass} button-left-icon`" data-name="cus-button"></i>
        <span v-html="text" data-name="cus-button"></span>
        <slot></slot>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cus-button',
  props: {
    color: { type: String, default: 'gray' },
    text: { type: String, default: '' },
    fontSize: { type: String, default: 'large' },
    width: { type: Number, default: 100 },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isButton: { type: Boolean, default: true },
    closeTransition: { type: Boolean, default: false },
    topIcon: { type: String, default: '' },
    leftIcon: { type: String, default: '' },
    buttonClass: { type: String, default: '' },
    textClass: { type: String, default: '' },
    topIconClass: { type: String, default: '' },
    leftIconClass: { type: String, default: '' },
  },
  data() {
    return {};
  },
  computed: {
    wrapClassObj() {
      let class_arr = [`width-${this.width}`, this.buttonClass];
      if (this.disabled) class_arr.push('button-disabled');
      if (!this.isButton) class_arr.push('is-not-button');
      return class_arr;
    },
    classObj() {
      let class_arr = ['button', `button-${this.color}`, `button-size-${this.fontSize}`];
      if (this.selected) class_arr.push('button-selected');
      if (this.disabled) class_arr.push('button-disabled');
      if (!this.isButton) class_arr.push('button-is-not');
      if (this.closeTransition) class_arr.push('button-no-transition');
      return class_arr;
    },
  },
};
</script>

<style lang="scss" scoped>
// 可自行新增顏色：分別設定初始狀態及focus狀態的(文字顏色/背景色/border顏色)
// keyname必須跟傳入的color string一致
$color-config: (
  gray: (
    color: $color-gray-70,
    bgc: $color-gray-3,
    border: $color-gray-10,
    focus-color: $color-lightBlue,
    focus-bgc: $color-gray-3,
    focus-border: $color-lightBlue,
  ),
  gray-noFocus: (
    color: $color-gray-70,
    bgc: $color-gray-3,
    border: $color-gray-10,
    focus-color: $color-gray-70,
    focus-bgc: $color-gray-3,
    focus-border: $color-gray-10,
  ),
  whiteGray: (
    color: $color-gray-30,
    bgc: #fff,
    border: $color-gray-20,
    focus-color: $color-gray-70,
    focus-bgc: #fff,
    focus-border: $color-gray-70,
  ),
  whiteBlue: (
    color: $color-blue,
    bgc: $color-whiteBlue,
    border: $color-whiteBlue,
    focus-color: $color-brightBlue,
    focus-bgc: $color-whiteBlue,
    focus-border: $color-whiteBlue,
  ),
  whiteYellow: (
    color: $color-gray-70,
    bgc: $color-whiteYellow,
    border: $color-whiteYellow,
    focus-color: $color-yellow,
    focus-bgc: $color-whiteYellow,
    focus-border: $color-whiteYellow,
  ),
  white: (
    color: $color-gray-70,
    bgc: #fff,
    border: $color-gray-10,
    focus-color: $color-lightBlue,
    focus-bgc: #fff,
    focus-border: $color-lightBlue,
  ),
  blue: (
    color: #fff,
    bgc: $color-blue,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-lightBlue,
    focus-border: transparent,
  ),
  lightBlue: (
    color: #fff,
    bgc: $color-lightBlue,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-lightBlue,
    focus-border: transparent,
  ),
  darkBlue: (
    color: #fff,
    bgc: $color-darkBlue,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-darkBlue,
    focus-border: #fff,
  ),
  red: (
    color: #fff,
    bgc: $color-red,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-lightRed,
    focus-border: transparent,
  ),
  yellow: (
    color: #fff,
    bgc: $color-yellow,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-lightYellow,
    focus-border: transparent,
  ),
  green: (
    color: #fff,
    bgc: $color-green,
    border: transparent,
    focus-color: #fff,
    focus-bgc: $color-lightGreen,
    focus-border: transparent,
  ),
  weekGreen: (
    color: $color-green,
    bgc: $color-weekGreen,
    border: transparent,
    focus-color: $color-green,
    focus-bgc: $color-weekGreen,
    focus-border: $color-green,
  ),
  green-border: (
    color: $color-green,
    bgc: #fff,
    border: $color-green,
    focus-color: $color-lightGreen,
    focus-bgc: #fff,
    focus-border: $color-lightGreen,
  ),
  opacity: (
    color: #fff,
    bgc: rgba(255, 255, 255, 0.16),
    border: transparent,
    focus-color: #fff,
    focus-bgc: rgba(255, 255, 255, 0.3),
    focus-border: transparent,
  ),
  transparent: (
    color: #fff,
    bgc: transparent,
    border: #fff,
    focus-color: #fff,
    focus-bgc: rgba(255, 255, 255, 0.3),
    focus-border: #fff,
  ),
);
@each $keyname, $value in $color-config {
  $color: map-get($value, color);
  $bgc: map-get($value, bgc);
  $border: map-get($value, border);
  $focus-color: map-get($value, focus-color);
  $focus-bgc: map-get($value, focus-bgc);
  $focus-border: map-get($value, focus-border);

  .button-#{'' + $keyname} {
    @include button-set($color, $bgc, $border);
    &:active {
      @include button-set($focus-color, $focus-bgc, $focus-border);
    }
  }
}
.cus-button-wrap {
  @include base-button-wrap;
}
.small-height {
  min-height: $small-button-min-height;
}
.button {
  @include base-button;
}
</style>
